<template>
  <a
    :href="item.route"
    @click.prevent="changeRoute(item.route)"
  >
    <div
      v-if="!item.disabled"
      class="routing__item"
      :class="{
        'routing__item_active': activeRoute === item.route,
        'routing__item_disabled': rubrics && !rubrics.length && item.id !== 'news',
      }"
    >
      <SvgIcon
        :name="item.icon"

        @mouseenter="isShowTooltip = true"
        @mouseleave="isShowTooltip = false"
      />

      <div
        v-if="isShowTooltip"
        class="router-tooltip"
      >
        {{ t('router_item.' + item.id) }}
      </div>
    </div>
  </a>
</template>

<script setup>
import SvgIcon from "@/components/common/svgButton.vue";
import {computed, ref, onMounted, onUnmounted} from "vue";
import {useRouter} from "vue-router";
import { t } from "@/controllerLK/GlobusLocalization";
import {useProjects} from "@/store/projects";
import {useStore} from "@/store";

// eslint-disable-next-line no-unused-vars
const props = defineProps({
  item: {
    type: Object,
    required: true,
  }
});

const router = useRouter();
const projectStore = useProjects();
const store = useStore();
const activeRoute = computed(() => router.currentRoute.value.fullPath);
const isShowTooltip = ref(false);

const changeRoute = (route) => {

  if (projectStore.projects.length === 0) {
    store.createNotify(t("toast.error.no_project"), "error");
    return false;
  }

  router.push(route);
};

const rubrics = ref(null);

function updateRubrics() {
  const data = localStorage.getItem("projectRubrics");
  rubrics.value = data ? JSON.parse(data).map(rubric => rubric.name) : null;
}

onMounted(() => {
  window.addEventListener("ChangeRubrics", updateRubrics);
});

onUnmounted(() => {
  window.removeEventListener("ChangeRubrics", updateRubrics);
});

</script>

<style lang="scss" scoped>

.router-tooltip {
  position: absolute;
  top: 44px;
  left: 0;
  padding: 5px 8px;
  color: black;
  font-size: 12px;
  line-height: 14px;
  border-radius: 10px;
  background: white;
  z-index: 2000;
  white-space: nowrap;
  box-shadow: 0 0 33px 0 rgb(0 0 0 / 16%)
}

.routing__item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  cursor: pointer;
  color: #7B87A5;
  border-radius: 50%;
  transition: all .3s ease-in-out;

  &_active {
    color: #1F9AFF;
    background: #F4F7FE;
  }

  &_disabled {
    color: #A7A7A7;
    cursor: default;
  }

  &:hover {
    background: #F4F7FE;
  }

  svg {
    width: 18px;
    height: 18px;
  }
}
</style>
